import React, { useState, useEffect } from 'react';
import './CookieBanner.css';

const CONSENT_KEY = 'libbenincorp_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(CONSENT_KEY);
    if (!saved) setVisible(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem(CONSENT_KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Aviso de cookies">
      <div className="cookie-banner-inner">
        <div className="cookie-banner-text">
          <strong>Nos usamos cookies</strong>
          <p>
            Usamos cookies essenciais para o funcionamento do site e, com seu consentimento,
            cookies para entender como ele e usado. Saiba mais na{' '}
            <a href="/privacidade" className="cookie-banner-link">Politica de Privacidade</a>
            {' '}e na{' '}
            <a href="/cookies" className="cookie-banner-link">Politica de Cookies</a>.
          </p>
        </div>
        <div className="cookie-banner-actions">
          <button className="cookie-btn cookie-btn-deny" onClick={() => decide('denied')}>
            Recusar
          </button>
          <button className="cookie-btn cookie-btn-accept" onClick={() => decide('accepted')}>
            Aceitar
          </button>
        </div>
      </div>
    </div>
  );
}
